"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalNavbar = void 0;

var react_1 = __importDefault(require("react"));

var identity_1 = require("../../identity");

var utils_1 = require("../../utils");

var HorizontalNavbar = function HorizontalNavbar(_a) {
  var menuItems = _a.menuItems,
      isMenuVisible = _a.isMenuVisible,
      toggleMenuVisible = _a.toggleMenuVisible,
      branding = _a.branding,
      theme = _a.theme,
      _b = _a.stickyHeader,
      stickyHeader = _b === void 0 ? false : _b;
  var brandingStyle = "flex px-5 md:px-8 text-base sm:text-xl font-semibold sm:font-bold " + (theme ? theme.body.textSecondaryColor : 'text-gray-200');
  var brandingComp = react_1["default"].createElement("span", {
    className: brandingStyle,
    id: "navbar-logo",
    title: "Branding"
  }, react_1["default"].createElement("a", {
    href: "/",
    title: "Branding, navigate to the home page"
  }, branding));
  var wrapperStyle = "flex flex-row items-center justify-between h-12 md:h-16 " + (theme ? theme.body.backgroundColor : 'bg-gray-800') + " " + (theme ? theme.body.textSecondaryColor : 'text-gray-200') + " " + (stickyHeader ? 'fixed w-full z-10' : '');
  var navStyle = "fixed flex flex-col top-0 right-0 w-2/3 md:w-1/3 h-screen z-40 bg-sgreen-100 " + (theme ? theme.body.textSecondaryColor : 'text-gray-200') + " transition-all duration-300 ease-in-out " + (isMenuVisible ? 'bg-opacity-75' : 'bg-opacity-0');
  var menuItemStyle = "pt-6 pb-2 w-full border-b " + (theme ? theme.body.borderColor : 'border-gray-300') + " hover:" + (theme ? theme.form.borderHoverColor : 'border-red-600') + " " + (theme ? theme.body.textSecondaryColor : 'text-gray-200') + " hover:" + (theme ? theme.link.hoverColor : 'text-red-600') + " cursor-pointer";
  return react_1["default"].createElement("header", {
    id: "horizontal-navbar-header",
    className: "" + (stickyHeader ? 'mb-16' : '')
  }, react_1["default"].createElement("div", {
    className: wrapperStyle
  }, brandingComp, !isMenuVisible && react_1["default"].createElement("div", {
    className: "flex pr-3"
  }, react_1["default"].createElement("button", {
    className: "" + (theme ? theme.body.textSecondaryColor : 'text-gray-200'),
    "aria-label": "Open sidebar",
    title: "Open sidebar",
    onClick: function onClick() {
      return toggleMenuVisible(true);
    }
  }, react_1["default"].createElement(identity_1.Pictogram, {
    name: "hamburger_menu",
    size: identity_1.PictogramSize.xs
  }))), isMenuVisible && react_1["default"].createElement("nav", {
    id: "horizontal-navbar",
    className: navStyle,
    onClick: function onClick() {
      return toggleMenuVisible(false);
    }
  }, react_1["default"].createElement("div", {
    className: "flex"
  }, react_1["default"].createElement("button", {
    className: "" + (theme ? theme.body.textSecondaryColor : 'text-gray-200'),
    "aria-label": "Close sidebar",
    title: "Close sidebar",
    onClick: function onClick() {
      return toggleMenuVisible(false);
    }
  }, react_1["default"].createElement(identity_1.Pictogram, {
    name: "hamburger_menu_close",
    size: identity_1.PictogramSize.xs
  }))), react_1["default"].createElement("ul", {
    className: "px-6 w-full"
  }, menuItems.map(function (item) {
    return react_1["default"].createElement("li", {
      key: item.title,
      onClick: function onClick() {
        return (0, utils_1.openUrl)(item.link);
      },
      className: menuItemStyle
    }, react_1["default"].createElement("a", {
      href: item.link,
      title: item.title,
      className: "text-md"
    }, item.text));
  })))));
};

exports.HorizontalNavbar = HorizontalNavbar;